<template>
  <section class="w-full">
    <div class="pda-default">
      <div class="t-headline5">
        {{ $t("S10060") }}
      </div>
    <div class="t-body3 mgt-6 t-color-content1">
      {{ $t('S10061') }}
    </div>
    <div class="mgt-35">
      <div class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full"
           :class="deleteReasonInvalidCheck ? 'mdc-text-field--invalid' : deleteReason !== '' ? 'textFieldVal' : ''"
           id="requestWithdrawalEl">
        <i class="material-icons mdc-text-field__icon">
          {{ deleteReasonValidIcon }}
        </i>
        <input
            type="text"
            class="mdc-text-field__input"
            name="deleteReason"
            v-model="deleteReason"
            v-validate="'required'"
            ref="deleteReason"
            id="deleteReason"
            maxlength="100"
        />
        <div class="mdc-notched-outline">
          <div class="mdc-notched-outline__leading"></div>
          <div class="mdc-notched-outline__notch">
            <label for="tf-outlined" class="mdc-floating-label">{{ $t('S10062') }}</label>
          </div>
          <div class="mdc-notched-outline__trailing"></div>
        </div>
      </div>
      <div class="t-helper mgl-7 mgr-7 pdt-2 min-h-23" :class="deleteReasonInvalidCheck ? 't-color-secondary': 't-color-textfieldActive'">
        <span>
          {{ deleteReasonInvalidCheck ? $t("S10066") : $t("S10063") }}
        </span>
      </div>
    </div>
    <div class="mgt-38">
      <button
          class="mdc-button mdc-button--raised btn-red"
          @click="requestDelete()"
      >
        {{ $t("S10064") }}
        <!-- 완료 -->
      </button>
      <button
          class="mdc-button btn-white mgr-8 mgl-8"
          type="button"
          @click="cancelDelete()"
      >
        {{ $t("S10065") }}
        <!-- 취소 -->
      </button>
    </div>
    </div>
  </section>
</template>

<script>
import {MDCTextField} from "@material/textfield";
import { MDCRipple } from "@material/ripple";
import memberApi from "@/api/memberApi";

export default {
  name: "Withdrawal",

  data() {
    return {
      withdrawalTextField: null,
      deleteReasonValidIcon: "",
      deleteReason: ""
    };
  },

  computed: {
    deleteReasonInvalidCheck() {
      if (this.errors.has("deleteReason")) {
        this.deleteReasonValidIcon = "warning";
        return true;
      } else {
        this.deleteReasonValidIcon = "";
        return false;
      }
    },
  },

  mounted() {
    this.setMaterialUi();
    this.$refs.deleteReason.focus();
    console.log('this.$refs.deleteReason.focus()', this.$refs.deleteReason.focus())
  },

  methods: {
    // 탈퇴 요청(request delete)
    requestDelete() {
      this.$validator.validateAll().then((resultValid) => {
        if (resultValid) {
          let params;
          params = {
            reason: this.deleteReason,
          };

          let alertData = "";
          alertData = {
            title: this.$t("S10067"), // 회원 탈퇴 요청 완료
            content: this.$t("S10068"), // 관리자가 확인 후 최대 7일 이내에 처리됩니다.
          };

          this.$alert(alertData)
              .then(() => {
                memberApi
                    .deleteAccount(params)
                    .then((response) => {
                      this.$router.go(-1);
                    })
                    .catch((error) => {
                      console.log(error);
                      this.$router.go(-1);
                    });
              })
              .catch((error) => {
                console.log(error);
              });
        }
      });
    },

    cancelDelete() {
      this.$router.go(-1);
    },

    setMaterialUi() {
      this.withdrawalTextField = new MDCTextField(document.querySelector('#requestWithdrawalEl'));
      this.withdrawalTextField = false;

      const buttonRipple = [].map.call(
          document.querySelectorAll(".mdc-button"),
          function(el) {
            let button = new MDCRipple.attachTo(el);
            return button;
          }
      );
    },
  },
}
</script>

<style scoped>
</style>